<template>
  <w-icon-wrapper
    :height='9.75'
    :width='24'
    icon-name='work-key-icon'
    view-box='0 0 24 9.75'
  >
    <path
      id='_66_Key_Icon'
      d='M23,9.75H8.88a4.5,4.5,0,1,0,0,2H16V14a1,1,0,0,0,2,0V11.75h2V15a1,1,0,0,0,2,0V11.75h1a1,1,0,0,0,0-2ZM4.5,13.25A2.5,2.5,0,1,1,7,10.75,2.5,2.5,0,0,1,4.5,13.25Z'
      data-name='66 Key_Icon'
      fill='currentColor'
      transform='translate(0 -6.25)'
    />
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconKey' };
</script>
